// List of all weather stations
import Leaflet from "leaflet";

const mIcon: Leaflet.DivIcon = Leaflet.divIcon({
  className: "number-icon",
  html: `<div style="background-color: gray; margin: 0px; color:white;">M</div>`,
  iconSize: [21, 25],
});

const arrowPath: string = `M 63.50,-0.50 C 105.17,-0.50 146.83,-0.50 188.50,-0.50 
                            188.28,99.50 188.61,199.50 189.50,299.50 210.50,299.50 
                            231.50,299.50 252.50,299.50 252.50,300.50 252.50,301.50
                            252.50,302.50 210.17,371.16 168.83,440.49 128.50,510.50 
                            126.83,510.50 125.17,510.50 123.50,510.50 88.36,450.89 
                            53.19,391.22 18.00,331.50 11.81,321.76 5.64,312.09 
                            -0.50,302.50 -0.50,301.50 -0.50,300.50 -0.50,299.50 
                            20.50,299.50 41.50,299.50 62.50,299.50 63.39,199.50 
                            63.72,99.50 63.50,-0.50 Z`;

const variablePath: string = `M14,7.5c0,3.5899-2.9101,6.5-6.5,6.5S1,11.0899,1,7.5S3.9101,1,
                               7.5,1S14,3.9101,14,7.5z`;

export function windMarker(meanWind: string, dir: string): Leaflet.DivIcon {
  var windFloat: number = parseFloat(meanWind);

  if (meanWind === "M") {
    return mIcon;
  }

  var angle: string = setAngleOfWindArrow(dir);

  if (angle === "-1") {
    return Leaflet.divIcon({
      html: `<svg width="25" height="25" viewBox="0 0 15 15" 
                    version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <path fill="${setColorOfWindArrow(
                      windFloat
                    )}" d="${variablePath}"/></svg>`,
      className: "svg-icon",
      iconSize: [25, 25],
      iconAnchor: [12, 14],
    });
  }

  return Leaflet.divIcon({
    html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 253 511" 
                    style="enable-background:new 0 0 253 511" 
                    transform="rotate(${angle})" xml:space="preserve">
                    <path fill="${setColorOfWindArrow(
                      windFloat
                    )}" d="${arrowPath}"/>
               </svg>`,
    className: "svg-icon",
    iconSize: [25, 25],
    iconAnchor: [11, 25],
  });
}

function setColorOfWindArrow(wind: number): string {
  switch (true) {
    case wind >= 220.0:
      return "#FF00FF";
    case wind >= 184.0:
      return "#ff7800";
    case wind >= 150.0:
      return "#cf7572ff";
    case wind >= 118.0:
      return "red";
    case wind >= 88.0:
      return "blue";
    case wind >= 63.0:
      return "green";
    case wind >= 41.0:
      return "black";
    default:
      return "gray"; //gray
  }
}
function setAngleOfWindArrow(dir: string): string {
  switch (dir) {
    case "N":
      return "0";
    case "NE":
      return "45";
    case "E":
      return "90";
    case "SE":
      return "135";
    case "S":
      return "180";
    case "SW":
      return "225";
    case "W":
      return "270";
    case "NW":
      return "315";
    case "Variable":
      return "-1";
    default:
      return "-1";
  }
}
